import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getCustomerLimit, fetchBeneficiaryList, deleteBeneficiaryApi } from 'utils/API/Merchant APIs/UpdatedAPIs/DMTUpdatedAPICalls';

import { checkMerchantOrBCAPI } from 'utils/API/Merchant APIs/MerchantApiCalls';
import { globalNotifySuccess } from 'views/utilities/AlertToast';
import { handleCatchError } from 'utils/CatchHandler';
import { QUERY_KEYS } from './QueryKeys';

export const useTransactionLimit = (customerMobile, dmtType = 1) => {
    return useQuery({
        queryKey: QUERY_KEYS.TRANSACTION_LIMIT(customerMobile, dmtType),
        queryFn: async () => {
            const payload = { customerMobileNo: customerMobile, dmtType };
            const response = await getCustomerLimit(payload);
            return response?.data?.data?.sendupto || '';
        },
        enabled: !!customerMobile,
        staleTime: 5 * 60 * 1000
    });
};

export const useBeneficiaryDetails = (customerId, page, limit, search) => {
    const { data, isLoading, isError } = useQuery({
        queryKey: QUERY_KEYS.BENEFICIARY_LIST(customerId, page, limit, search),
        queryFn: async () => {
            const response = await fetchBeneficiaryList(2, customerId, page, limit, search);

            if (response?.response?.status === 404) {
                throw new Error(response?.response?.data?.message || 'Not Found');
            }
            return {
                benfDetails: response?.data?.data?.result || [],
                totalCount: response?.data?.data?.pagination?.totalCount || 0
            };
        },
        enabled: !!customerId,
        retry: false
    });
    return { benefDetails: data?.benfDetails, totalCount: data?.totalCount, isLoading, isError };
};

export const useCheckIsMerchantOrBc = () => {
    return useQuery({
        queryKey: QUERY_KEYS.CHECK_MERCHANT_OR_BC,
        queryFn: async () => {
            const agentid = localStorage.getItem('id');
            const shouldshowEsign = localStorage.getItem('shouldshowEsign');
            const payloadCheck = { agentid };
            const merchantBcCheckResponse = await checkMerchantOrBCAPI(payloadCheck);

            const agentType = merchantBcCheckResponse?.data?.agentType;
            const pendingStatus = merchantBcCheckResponse?.data?.isPending;

            return {
                isBcConvertPending: pendingStatus,
                shouldOpenModal: agentType === 'Merchant' || pendingStatus || shouldshowEsign === 'true'
            };
        },
        staleTime: Infinity
    });
};

export const useDeleteBeneficiary = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (row) => {
            const payload = {
                beneMob: row?.mobileNumber,
                ifscCode: row?.ifscCode,
                accountno: row?.accountNumber,
                beneId: row?.id,
                agentId: String(2)
            };
            return await deleteBeneficiaryApi(payload);
        },
        onSuccess: (response) => {
            if (response?.data?.success) {
                globalNotifySuccess(response?.data?.message);
            }
            queryClient.invalidateQueries(QUERY_KEYS.BENEFICIARY_LIST);
        },
        onError: (error) => {
            console.log(error.message);
            handleCatchError(error);
        }
    });
};
